import template from './usersRoleSelector.html';
import './usersRoleSelector.scss';

export class UsersRoleSelector {
  constructor($timeout, appUtils) {
    'ngInject';

    this.$timeout = $timeout;
    this.appUtils = appUtils;
    this.showRoles = false;
    this.windowListenerAttached = false;

    this._onClickOnWindow = this._onClickOnWindow.bind(this);
  }
  $onDestroy() {
    this._removeWindowListener();
  }
  openRoles($event) {
    $event.preventDefault();
    this.showRoles = true;
    this.$timeout(() => this._addWindowListener());
  }
  closeRoles() {
    this.showRoles = false;
    this._removeWindowListener();
  }
  closeRolesAfterEvent() {
    this.$timeout(() => this.closeRoles());
  }
  onRolesClick($event) {
    $event.stopPropagation();
  }
  handleRoleSelection(role) {
    if (role.id !== this.selectedRole.id) {
      this.onSelection({ role });
    }
  }
  handleRoleSettings(role) {
    this.onSettings({ role });
  }
  _addWindowListener() {
    if (!this.windowListenerAttached) {
      this.appUtils.attachWindowEvents('click', this._onClickOnWindow);
      this.windowListenerAttached = true;
    }
  }
  _removeWindowListener() {
    if (this.windowListenerAttached) {
      this.appUtils.detachWindowEvents('click', this._onClickOnWindow);
      this.windowListenerAttached = false;
    }
  }
  _onClickOnWindow(event) {
    if (this.showRoles) {
      event.stopPropagation();
      event.preventDefault();
      this.closeRolesAfterEvent();
    }
  }
}

export default {
  controller: UsersRoleSelector,
  template,
  bindings: {
    roles: '<',
    rolesWithSettings: '<',
    selectedRole: '<',
    onSelection: '&',
    onSettings: '&',
  },
};
